import { Swiper } from 'swiper'
import {
  Navigation,
  Pagination,
} from 'swiper/modules'

if ($('.js-eventsSlider').length > 0) {
  new Swiper('.js-eventsSlider', {
    modules: [Navigation, Pagination],
    spaceBetween: 5,
    slidesPerView: 1,
    pagination: {
      el: '.js-eventsSliderPagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.js-eventsSliderNext',
      prevEl: '.js-eventsSliderPrev',
    },
    breakpoints: {
      768: {
        spaceBetween: 11,
      },
      1024: {
        spaceBetween: 20,
      },
    },
  })
}
